(function () {
  if (window.__mbPdp) return;
  window.__mbPdp = true;

  /* Product types to search for each category (custom.category). */
  var TYPES = {
    'Earrings': ['Earrings'],
    'Rings': ['Rings'],
    'Bracelets': ['Bracelets', 'Bangles'],
    'Necklaces': ['Necklaces'],
    'Pendants': ['Pendants'],
    'Necklace Sets': ['Necklace Set'],
    'Pendant Sets': ['Pendant Set']
  };
  /* Used only when a product has no category filled in yet. */
  var TYPE_CAT = {
    'Earrings': 'Earrings', 'Ear Cuffs': 'Earrings', 'Rings': 'Rings',
    'Bracelets': 'Bracelets', 'Bangles': 'Bracelets', 'Chain Bracelets': 'Bracelets',
    'Pendant Set': 'Pendant Sets', 'Pendants': 'Pendants',
    'Necklace Set': 'Necklace Sets', 'Necklaces': 'Necklaces', 'Necklace': 'Necklaces'
  };
  /* What goes with what. Sets already include earrings, so earrings come last there,
     and a pair of earrings is matched with necklaces that do not include earrings. */
  var PLAN = {
    'Earrings': [['Necklaces', 'Pendants'], ['Bracelets'], ['Rings']],
    'Necklaces': [['Earrings'], ['Bracelets'], ['Rings']],
    'Pendants': [['Earrings'], ['Bracelets'], ['Rings']],
    'Necklace Sets': [['Bracelets'], ['Rings'], ['Earrings']],
    'Pendant Sets': [['Bracelets'], ['Rings'], ['Earrings']],
    'Bracelets': [['Rings'], ['Earrings'], ['Pendants', 'Pendant Sets', 'Necklaces', 'Necklace Sets']],
    'Rings': [['Bracelets'], ['Earrings'], ['Pendants', 'Pendant Sets', 'Necklaces']]
  };
  var QUOTA = [3, 3, 2];
  var LOOSE_STYLE = { 'Bracelets': 1, 'Rings': 1 };
  /* Words for each attribute value: used to search for candidates, and to read
     attributes from the title when a product has no attributes filled in yet. */
  var WORDS = {
    colour: {
      'Green': ['emerald', 'green', 'mint', 'olive'],
      'Red': ['ruby', 'red', 'maroon', 'wine'],
      'Pink': ['pink', 'magenta', 'blush'],
      'Blue': ['blue', 'sapphire', 'navy', 'turquoise', 'teal', 'aqua'],
      'Purple': ['purple', 'amethyst', 'lavender', 'violet', 'lilac'],
      'Yellow': ['yellow', 'citrine', 'mustard'],
      'Orange & Peach': ['peach', 'orange', 'coral'],
      'Champagne & Brown': ['champagne', 'brown'],
      'Black': ['black', 'onyx'],
      'Grey': ['grey', 'gray'],
      'White & Clear': ['white', 'ivory', 'clear'],
      'Multicolour': ['multicolour', 'multicolor', 'navratna', 'rainbow', 'multi']
    },
    stone: {
      'Pearl': ['pearl', 'pearls', 'moti'],
      'Kundan & Polki': ['kundan', 'polki', 'jadau'],
      'American Diamond': ['diamond', 'american diamond'],
      'Crystal & Zircon': ['zircon', 'crystal', 'pave', 'solitaire'],
      'Natural Stone': ['stone', 'natural stone', 'gemstone', 'agate', 'quartz'],
      'Monalisa Stone': ['monalisa'],
      'Korean Glass': ['korean'],
      'Enamel & Meenakari': ['enamel', 'meenakari'],
      'Beads': ['beaded', 'beads', 'bead'],
      'Mother of Pearl & Shell': ['shell', 'mother of pearl', 'abalone']
    },
    motif: {
      'Floral': ['floral', 'flower', 'lotus', 'daisy', 'petal', 'blossom'],
      'Butterfly': ['butterfly'],
      'Leaf & Vine': ['leaf', 'vine', 'leaves'],
      'Heart': ['heart'],
      'Peacock & Bird': ['peacock', 'bird'],
      'Elephant': ['elephant'],
      'Bow & Ribbon': ['bow', 'ribbon'],
      'Geometric': ['geometric', 'square', 'hexagon', 'triangle'],
      'Star & Celestial': ['star', 'moon', 'celestial'],
      'Snake': ['snake', 'serpent'],
      'Temple & Deity': ['temple', 'lakshmi', 'laxmi', 'coin', 'goddess'],
      'Infinity & Twist': ['infinity', 'twist'],
      'Tribal & Mandala': ['tribal', 'mandala']
    }
  };
  var FINISH_WORD = { 'Gold': 'gold', 'Antique Gold': 'antique', 'Rose Gold': 'rose', 'Silver': 'silver', 'Oxidised Silver': 'oxidised', 'Dual Tone': 'oxidised' };
  /* Finishes that sit well together even though they are not the same. */
  var FINISH_NEAR = {
    'Gold|Antique Gold': 2.5, 'Antique Gold|Gold': 2.5,
    'Dual Tone|Oxidised Silver': 3, 'Oxidised Silver|Dual Tone': 3,
    'Dual Tone|Antique Gold': 2, 'Antique Gold|Dual Tone': 2,
    'Dual Tone|Gold': 0, 'Gold|Dual Tone': 0,
    'Dual Tone|Silver': 0, 'Silver|Dual Tone': 0,
    'Silver|Oxidised Silver': -2, 'Oxidised Silver|Silver': -2,
    'Gold|Rose Gold': -1, 'Rose Gold|Gold': -1,
    'Antique Gold|Oxidised Silver': -2, 'Oxidised Silver|Antique Gold': -2
  };
  var STONE_NEAR = {
    'Crystal & Zircon|American Diamond': 1.5, 'American Diamond|Crystal & Zircon': 1.5,
    'Kundan & Polki|Pearl': 1, 'Pearl|Kundan & Polki': 1,
    'Pearl|Mother of Pearl & Shell': 1, 'Mother of Pearl & Shell|Pearl': 1,
    'Natural Stone|Monalisa Stone': 1, 'Monalisa Stone|Natural Stone': 1,
    'Natural Stone|Beads': 1, 'Beads|Natural Stone': 1
  };
  var EDIT_NEAR = {
    'Heritage & Temple|Bridal & Reception': 1, 'Bridal & Reception|Heritage & Temple': 1,
    'Minimal Everyday|Modern Edit': 1, 'Modern Edit|Minimal Everyday': 1,
    'Festive Glam|Party Wear': 1, 'Party Wear|Festive Glam': 1,
    'Festive Glam|Bridal & Reception': 1, 'Bridal & Reception|Festive Glam': 1,
    'Statement Drama|Party Wear': 1, 'Party Wear|Statement Drama': 1,
    'Pearls & Pastels|Minimal Everyday': 1, 'Minimal Everyday|Pearls & Pastels': 1
  };
  var EDIT_TAG = {
    'style-heritage-temple': 'Heritage & Temple', 'style-bridal-reception': 'Bridal & Reception',
    'style-boho-earthy': 'Boho & Earthy', 'style-minimal-everyday': 'Minimal Everyday',
    'style-modern-edit': 'Modern Edit', 'style-festive-glam': 'Festive Glam',
    'style-arm-candy': 'Arm Candy', 'style-ring-edit': 'Ring Edit'
  };
  var UMB = { 'umbrella-ethnic': 'Ethnic', 'umbrella-western': 'Western', 'umbrella-voguish': 'Voguish' };
  var uid = 0;

  function has(text, word) {
    return new RegExp('(^|[^a-z])' + word + '([^a-z]|$)').test(text);
  }
  function setOf(str) {
    var o = {};
    (str || '').split('|').forEach(function (x) {
      x = x.replace(/^\s+|\s+$/g, '');
      if (x) o[x] = 1;
    });
    return o;
  }
  function keys(o) {
    var a = [];
    for (var k in o) a.push(k);
    return a;
  }
  function shared(a, b, skip) {
    var n = 0;
    for (var k in a) if (b[k] && !(skip && skip[k])) n++;
    return n;
  }
  function near(a, b, map) {
    var best = 0;
    for (var x in a) for (var y in b) {
      var v = map[x + '|' + y];
      if (v && v > best) best = v;
    }
    return best;
  }
  function fromWords(kind, text) {
    var out = {};
    for (var v in WORDS[kind]) {
      for (var i = 0; i < WORDS[kind][v].length; i++) {
        if (has(text, WORDS[kind][v][i])) { out[v] = 1; break; }
      }
    }
    return out;
  }
  function finishFromText(text) {
    var o = {};
    if (/rose[\s-]?gold/.test(text)) o['Rose Gold'] = 1;
    else if (/oxidi[sz]ed|german silver|black polish/.test(text)) o['Oxidised Silver'] = 1;
    else if (/silver|rhodium|platinum/.test(text)) o['Silver'] = 1;
    else if (/antique gold|matte gold/.test(text)) o['Antique Gold'] = 1;
    else if (/gold|golden|brass/.test(text)) o['Gold'] = 1;
    return o;
  }
  /* One product's attributes, read from an element's data attributes. */
  function signature(el) {
    var tags = {};
    (el.getAttribute('data-tags') || '').split('|').forEach(function (t) {
      if (t) tags[t.toLowerCase()] = 1;
    });
    var s = {
      cat: el.getAttribute('data-cat') || '',
      sub: el.getAttribute('data-sub') || '',
      style: setOf(el.getAttribute('data-style')),
      edit: setOf(el.getAttribute('data-edit')),
      finish: setOf(el.getAttribute('data-finish')),
      colour: setOf(el.getAttribute('data-colour')),
      stone: setOf(el.getAttribute('data-stone')),
      motif: setOf(el.getAttribute('data-motif')),
      occasion: setOf(el.getAttribute('data-occasion')),
      features: setOf(el.getAttribute('data-features')),
      tags: tags
    };
    if (!s.cat) {
      /* No attributes yet (a newly added product): read what we can from title and tags. */
      var title = (el.getAttribute('data-title') || '').toLowerCase();
      var tg = keys(tags).join(' | ');
      s.cat = TYPE_CAT[el.getAttribute('data-type') || ''] || '';
      s.finish = finishFromText(title);
      if (!keys(s.finish).length) s.finish = finishFromText(tg);
      s.colour = fromWords('colour', title);
      s.stone = fromWords('stone', title);
      s.motif = fromWords('motif', title);
      for (var t in tags) {
        if (UMB[t]) s.style[UMB[t]] = 1;
        if (EDIT_TAG[t]) s.edit[EDIT_TAG[t]] = 1;
      }
      if (tags['anti-tarnish'] || tags['anti tarnish']) s.features['Anti-Tarnish'] = 1;
      if (tags['demi-fine-jewellery']) s.features['Demi-Fine'] = 1;
    }
    return s;
  }

  function finishScore(a, b) {
    if (!keys(a).length || !keys(b).length) return 0;
    if (shared(a, b)) return 4;
    /* No finish in common: average every pairing, a pairing that does not go together counts as -6. */
    var sum = 0;
    var n = 0;
    for (var x in a) for (var y in b) {
      var v = FINISH_NEAR[x + '|' + y];
      sum += v === undefined ? -6 : v;
      n++;
    }
    return sum / n;
  }
  function colourScore(a, b) {
    var neutral = { 'White & Clear': 1 };
    var ca = keys(a).filter(function (k) { return !neutral[k]; });
    var cb = keys(b).filter(function (k) { return !neutral[k]; });
    var n = shared(a, b, neutral);
    if (n) return Math.min(n, 2) * 3;
    if (!ca.length && !cb.length) return a['White & Clear'] && b['White & Clear'] ? 1.5 : 0;
    if (!ca.length || !cb.length) return 0;
    if (a['Multicolour'] || b['Multicolour']) return 1;
    return -2;
  }
  function stoneScore(a, b) {
    var n = shared(a, b, { 'Plain Metal': 1 });
    if (n) return Math.min(n, 2) * 2;
    if (a['Plain Metal'] && b['Plain Metal']) return 2;
    return near(a, b, STONE_NEAR);
  }
  function score(me, price, c) {
    var o = c.sig;
    var s = finishScore(me.finish, o.finish);
    s += colourScore(me.colour, o.colour);
    s += stoneScore(me.stone, o.stone);
    s += Math.min(shared(me.motif, o.motif), 2) * 1.5;
    /* Bracelets and rings carry the style of the menu they sit under, not of how they look,
       so a different style only counts against a match between the other categories. */
    var loose = LOOSE_STYLE[me.cat] || LOOSE_STYLE[o.cat];
    if (keys(me.style).length && keys(o.style).length) s += shared(me.style, o.style) ? 1.5 : (loose ? 0 : -2.5);
    var skipEdit = { 'Arm Candy': 1, 'Ring Edit': 1 };
    s += shared(me.edit, o.edit, skipEdit) ? 2 : near(me.edit, o.edit, EDIT_NEAR);
    if (keys(me.occasion).length && keys(o.occasion).length) {
      var oc = shared(me.occasion, o.occasion);
      s += oc ? Math.min(oc, 3) * 0.5 : -2;
    }
    var demiA = !!me.features['Demi-Fine'];
    var demiB = !!o.features['Demi-Fine'];
    if (demiA && demiB) s += 2.5;
    else if (demiA !== demiB) s -= 1;
    if (me.features['Anti-Tarnish'] && o.features['Anti-Tarnish']) s += 0.5;
    if (o.tags['curated_bestseller']) s += 0.5;
    if (price && c.price) {
      var r = c.price / price;
      if (r >= 0.25 && r <= 1.6) s += 1;
      else if (r > 2.5) s -= 2;
    }
    return s;
  }
  function searchWords(me) {
    var out = [];
    function add(kind, skip) {
      for (var v in me[kind]) {
        if (skip[v] || !WORDS[kind][v]) continue;
        var n = 0;
        WORDS[kind][v].forEach(function (w) {
          if (n < 2 && w.indexOf(' ') < 0 && out.indexOf(w) < 0) { out.push(w); n++; }
        });
      }
    }
    add('stone', { 'Plain Metal': 1 });
    add('colour', { 'White & Clear': 1, 'Multicolour': 1 });
    add('motif', {});
    return out.slice(0, 6);
  }

  function typeQuery(cats) {
    var types = [];
    cats.forEach(function (c) { (TYPES[c] || []).forEach(function (t) { types.push(t); }); });
    return '(' + types.map(function (t) { return 'product_type:"' + t + '"'; }).join(' OR ') + ')';
  }
  function searchUrl(url, section, query) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + section +
      '&type=product&options%5Bunavailable_products%5D=hide&q=' + encodeURIComponent(query);
  }
  function cards(url, section, query) {
    var prefix = 'mbp' + (++uid) + 'x';
    return fetch(searchUrl(url, section, query), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html.split('mbcardsX').join(prefix), 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('li[data-product-id]'));
      });
  }
  function data(url, query) {
    return fetch(searchUrl(url, 'mb-product-data', query), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('li[data-id]')).map(function (li) {
          return {
            id: li.getAttribute('data-id'),
            price: (parseInt(li.getAttribute('data-price'), 10) || 0) / 100,
            sig: signature(li)
          };
        });
      })
      .catch(function () { return []; });
  }
  function idsIn(selector) {
    var o = {};
    document.querySelectorAll(selector).forEach(function (li) {
      o[li.getAttribute('data-product-id')] = 1;
    });
    return o;
  }
  function wireArrows(row) {
    var list = row.querySelector('.mb-row__list--slider');
    var prev = row.querySelector('[data-mb-prev]');
    var next = row.querySelector('[data-mb-next]');
    if (!list || !prev || !next) return;
    function upd() {
      row.classList.toggle('mb-row--static', list.scrollWidth <= list.clientWidth + 4);
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }
    function step(dir) {
      var item = list.querySelector('.mb-row__item');
      var w = item ? item.getBoundingClientRect().width + 16 : 300;
      list.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    list.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    row.__mbUpd = upd;
    upd();
  }
  function fill(el, lis) {
    var ul = el.querySelector('[data-mb-px-list]');
    lis.forEach(function (li) {
      li.className = 'mb-row__item';
      ul.appendChild(li);
    });
    el.hidden = false;
    wireArrows(el);
  }
  /* Drop anything that also shows in "You may also like" or in a row above. */
  function prune(el) {
    if (el.hidden) return;
    var taken = idsIn('product-recommendations li[data-product-id]');
    if (el.getAttribute('data-mb-px') === 'style') {
      /* Skip what the "Pairs well with" strip and the after-add sheet already show. */
      lookChosen.forEach(function (id) { taken[id] = 1; });
    }
    var keep = 0;
    Array.prototype.slice.call(el.querySelectorAll('[data-mb-px-list] > li')).forEach(function (li) {
      if (taken[li.getAttribute('data-product-id')]) li.parentNode.removeChild(li);
      else keep++;
    });
    if (keep < 4) el.hidden = true;
    else if (el.__mbUpd) el.__mbUpd();
  }
  function watchRelated(el) {
    var rel = document.querySelector('product-recommendations');
    if (!rel || !('MutationObserver' in window)) return;
    var timer = null;
    var mo = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { prune(el); }, 300);
    });
    mo.observe(rel, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  /* Candidates for one group of categories, best match first. */
  function candidates(url, cats, me, price, cur, queries) {
    var tq = typeQuery(cats);
    function merge(lists, into, seen) {
      lists.forEach(function (list) {
        list.forEach(function (c) {
          if (c.id === cur || seen[c.id] || cats.indexOf(c.sig.cat) < 0) return;
          seen[c.id] = 1;
          c.score = score(me, price, c);
          into.push(c);
        });
      });
    }
    var seen = {};
    var out = [];
    return Promise.all(queries.map(function (q) { return data(url, q + ' ' + tq); }))
      .then(function (lists) {
        merge(lists, out, seen);
        var good = out.filter(function (c) { return c.score >= 4; }).length;
        if (good >= 4) return null;
        return data(url, tq);
      })
      .then(function (extra) {
        if (extra) merge([extra], out, seen);
        out.sort(function (a, b) { return b.score - a.score; });
        return out;
      });
  }
  function choose(per) {
    var chosen = [];
    var quota = QUOTA.slice();
    function take(min) {
      for (var round = 0; round < 5; round++) {
        for (var g = 0; g < per.length; g++) {
          var grp = per[g];
          grp.taken = grp.taken || 0;
          grp.subs = grp.subs || {};
          if (grp.taken >= (quota[g] || 2) || chosen.length >= 8) continue;
          for (var i = 0; i < grp.length; i++) {
            var c = grp[i];
            if (c.used) continue;
            if (c.score < min) break;
            if (c.sig.sub && (grp.subs[c.sig.sub] || 0) >= 2) continue;
            c.used = true;
            grp.taken++;
            if (c.sig.sub) grp.subs[c.sig.sub] = (grp.subs[c.sig.sub] || 0) + 1;
            chosen.push(c);
            break;
          }
        }
      }
    }
    take(7);
    if (chosen.length < 8) take(4.5);
    if (chosen.length < 8) {
      quota = quota.map(function (q) { return q + 2; });
      take(4.5);
    }
    return chosen;
  }

  /* Complete the look: other jewellery categories, ranked by how well they match
     this piece's finish, colour, stone, motif, style, edit, occasion and range.
     The picks are worked out once per page and shown by the "Pairs well with"
     strip (first 4) and the after-add sheet (the rest), in assets/mb-pairs.js. */
  var lookPromise = null;
  var lookChosen = [];
  function lookIds(el) {
    if (lookPromise) return lookPromise;
    var me = signature(el);
    var plan = PLAN[me.cat];
    if (!plan) return (lookPromise = Promise.resolve([]));
    var cur = el.getAttribute('data-product-id');
    var url = el.getAttribute('data-search-url');
    var price = (parseInt(el.getAttribute('data-price'), 10) || 0) / 100;
    var umb = el.getAttribute('data-umbrella');
    var styleTag = el.getAttribute('data-style-tag');
    var queries = [];
    function add(q) { if (q && queries.indexOf(q) < 0) queries.push(q); }
    if (styleTag && styleTag.indexOf('style-') === 0 && styleTag !== 'style-arm-candy' && styleTag !== 'style-ring-edit') add('tag:' + styleTag);
    var fw = FINISH_WORD[keys(me.finish)[0]];
    if (umb && fw) add('tag:' + umb + ' ' + fw);
    else if (fw) add(fw);
    var words = searchWords(me);
    if (words.length) add('(' + words.join(' OR ') + ')');
    if (me.features['Demi-Fine']) add('tag:demi-fine-jewellery');
    if (umb) add('tag:' + umb);

    lookPromise = Promise.all(plan.map(function (cats) { return candidates(url, cats, me, price, cur, queries); }))
      .then(function (per) {
        el.__mbLook = { me: me, per: per, queries: queries };
        lookChosen = choose(per).map(function (c) { return String(c.id); });
        return lookChosen.slice();
      })
      .catch(function () { return []; });
    return lookPromise;
  }

  /* Shared with assets/mb-pairs.js. */
  window.MBLook = {
    el: function () { return document.querySelector('[data-mb-px="look"]'); },
    ids: function () {
      var el = this.el();
      return el ? lookIds(el) : Promise.resolve([]);
    },
    /* Light product data for a list of ids, in the same order. */
    mini: function (ids) {
      var el = this.el();
      if (!el || !ids.length) return Promise.resolve([]);
      return fetch(searchUrl(el.getAttribute('data-search-url'), 'mb-product-mini', ids.map(function (i) { return 'id:' + i; }).join(' OR ')), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var by = {};
          Array.prototype.slice.call(doc.querySelectorAll('li[data-id]')).forEach(function (li) {
            by[li.getAttribute('data-id')] = {
              id: li.getAttribute('data-id'),
              url: li.getAttribute('data-url'),
              variant: li.getAttribute('data-variant'),
              available: li.getAttribute('data-available') === 'true',
              multi: li.getAttribute('data-multi') === '1',
              title: li.getAttribute('data-title') || '',
              price: li.getAttribute('data-price') || '',
              compare: li.getAttribute('data-compare') || '',
              img: li.getAttribute('data-img') || ''
            };
          });
          return ids.map(function (i) { return by[i]; }).filter(Boolean);
        })
        .catch(function () { return []; });
    }
  };

  function style(el) {
    var tag = el.getAttribute('data-style-tag');
    if (!tag) return;
    var cur = el.getAttribute('data-product-id');
    cards(el.getAttribute('data-search-url'), 'mb-product-cards', 'tag:' + tag)
      .then(function (lis) {
        var out = lis.filter(function (li) { return li.getAttribute('data-product-id') !== cur; });
        if (out.length >= 4) {
          fill(el, out);
          prune(el);
          watchRelated(el);
        }
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-mb-px]').forEach(function (el) {
      if (el.__mb) return;
      el.__mb = true;
      /* The "look" section is no longer drawn as a row: it only carries this product's
         data for the "Pairs well with" strip and the after-add sheet (assets/mb-pairs.js). */
      if (el.getAttribute('data-mb-px') === 'look') return;
      var go = function () { style(el); };
      var sentinel = el.previousElementSibling;
      if ('IntersectionObserver' in window && sentinel && sentinel.hasAttribute('data-mb-px-sentinel')) {
        var io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { io.disconnect(); go(); }
        }, { rootMargin: '0px 0px 900px 0px' });
        io.observe(sentinel);
      } else {
        go();
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
